import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-techtape',
  template: `
    <sbnb-apps-detail-page
      vendorCode="techtape"
      name="TechTape"
      logoTile="/assets/images/apps/techtape.png"
      builtBy="TechTape"
      builtByLink="https://www.gettechtape.com/"
      [categories]="['Professional services']"
      [permissions]="[AppPermission.propertyRead, AppPermission.reservationRead, AppPermission.calendarRead]"
      email="support@gettechtape.com"
      [helpArticles]="[
        {
          id: '9250485',
          title: 'Connecting Hospitable with TechTape'
        }
      ]">
      <div style="position: relative; padding-bottom: 62.5%; height: 0;">
        <iframe
          src="https://www.loom.com/embed/cc4db90d4947447fa32d8defbfde0d01?sid=68056114-6b77-4972-8284-914d2e629641"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
      </div>
      <ng-container description>
        <p>
          TechTape provides revenue management services for short-term rental operators. TechTape is a professional
          service, not a software.
        </p>

        <p>
          Our integration with Hospitable enables us to use the most accurate booking information as we analyze your
          revenue performance, and develop and implement a revenue strategy that is tailored to your unique goals and
          business needs. TechTape utilizes the best-in-class technologies and software to deliver exceptional revenue
          performance for your short-term rental portfolio!
        </p>

        <p>
          You need to have an active account with TechTape prior to enabling this integration. Before activating this
          integration, please fill out this
          <a href="https://www.gettechtape.com/form" target="_blank">form</a>
          to schedule a call to learn more about our services. Once you have an active account with TechTape, click Get
          Started to enable the TechTape integration with Hospitable.
        </p>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
  styleUrls: ['./techtape.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TechtapeComponent {
  AppPermission = AppPermission;
}
